import { render, staticRenderFns } from "./VehicleAssignmentEditor.vue?vue&type=template&id=51144bad&scoped=true"
import script from "./VehicleAssignmentEditor.vue?vue&type=script&lang=js"
export * from "./VehicleAssignmentEditor.vue?vue&type=script&lang=js"
import style0 from "./VehicleAssignmentEditor.vue?vue&type=style&index=0&id=51144bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51144bad",
  null
  
)

export default component.exports